import { render } from "./OrderHeader.vue?vue&type=template&id=390a6bba&scoped=true&ts=true"
import script from "./OrderHeader.vue?vue&type=script&lang=ts"
export * from "./OrderHeader.vue?vue&type=script&lang=ts"

import "./OrderHeader.vue?vue&type=style&index=0&id=390a6bba&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390a6bba"]])

export default __exports__